import React,{useState,useEffect} from 'react'
import axios from 'axios'
import StatTile from '../ui/StatTile'
import './dashboard.css'

export default function DashboardGeneralStats() {
  const [activeSessions,setActiveSessions]=useState(0)
  const [activeSessionsEngaged,setActiveEngaged]=useState(0)
  const [activeSessionsChallenges,setActiveSessionsChallenges]=useState(0)
  const [loadingSessions,setLoadingSessions]=useState(true)
  const [loadingEngaged,setLoadingEngaged]=useState(true)
  const [loadingChallenges,setLoadingChallenges]=useState(true)

  useEffect(()=>{
    loadData()
    loadDataChallnges()
    loadDataEngaged()
},[])

const loadData=()=>{
  const obj={
    SportID:sessionStorage.getItem('SportID'),
    Countries:JSON.parse(sessionStorage.getItem('appCountries'))
}

    setLoadingSessions(true)
    axios.post(process.env.REACT_APP_API_SERVER+'manager/dashboard/dashboardgenstatsactivesessions',obj,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
          }
      })
    .then(res=>{
      setActiveSessions(res.data.results[0].ActiveSessions)
        setLoadingSessions(false)
    }).catch(err=>{
        setLoadingSessions(false)

    })
}

const loadDataChallnges=()=>{
  const obj={
    SportID:sessionStorage.getItem('SportID'),
    Countries:JSON.parse(sessionStorage.getItem('appCountries'))
}

    setLoadingChallenges(true)
    axios.post(process.env.REACT_APP_API_SERVER+'manager/dashboard/dashboardgenstatschellenges',obj,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
          }
      })
    .then(res=>{
      setActiveSessionsChallenges(res.data.results[0].ActiveSessions)
        setLoadingChallenges(false)
    }).catch(err=>{
        setLoadingChallenges(false)

    })
}


const loadDataEngaged=()=>{
  const obj={
    SportID:sessionStorage.getItem('SportID'),
    Countries:JSON.parse(sessionStorage.getItem('appCountries'))
}

    setLoadingEngaged(true)
    axios.post(process.env.REACT_APP_API_SERVER+'manager/dashboard/dashboardgenstatsengaged',obj,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
          }
      })
    .then(res=>{
      setActiveEngaged(res.data.results[0].ActiveSessions)
        setLoadingEngaged(false)
    }).catch(err=>{
        setLoadingEngaged(false)

    })
}

  const isLoading=loadingSessions || loadingEngaged || loadingChallenges

  const sessions=Number(activeSessions) || 0
  const engaged=Number(activeSessionsEngaged) || 0
  const challengers=Number(activeSessionsChallenges) || 0

  const share=(part,whole)=>whole>0 ? Math.round((part/whole)*100) : null

  const engagedShare=share(engaged,sessions)
  const challengeShare=share(challengers,engaged)

  return (
    <section className="scoreboard" aria-label="Key figures">

      <div className="sb-head">
        <span className="mono">Statistics</span>
        <span className="sb-live">
          <span className={isLoading ? 'dot dot-idle' : 'dot'}></span>
          <span className="mono">{isLoading ? 'Loading' : 'Updated 1 hour ago'}</span>
        </span>
      </div>

      <div className="sb-grid">
        <StatTile
          index={0}
          label="Active Sessions"
          value={sessions}
          note="Players who opened the app in the current window."
        />

        <StatTile
          index={1}
          label="Engaged Users"
          value={engaged}
          note={engagedShare === null
            ? 'No active sessions to compare against yet.'
            : <><b>{engagedShare}%</b> of active sessions produced an action.</>}
        />

        <StatTile
          index={2}
          label="Challenge Participants"
          value={challengers}
          note={challengeShare === null
            ? 'No engaged users to compare against yet.'
            : <><b>{challengeShare}%</b> of engaged users entered a challenge.</>}
        />
      </div>

    </section>
  )
}
